export const icons: { [name: string]: { type: string; icon: string } } = {
  animals: { type: 'fa', icon: 'fa-regular fa-cat' },
  animals2: { type: 'fa', icon: 'fa-regular fa-dolphin' },
  bat: { type: 'fa', icon: 'fa-regular fa-bat' },
  bee: { type: 'fa', icon: 'fa-regular fa-bee' },
  bird: { type: 'fa', icon: 'fa-regular fa-bird' },
  butterfly: { type: 'fa', icon: 'fa-regular fa-butterfly' },
  body: { type: 'fa', icon: 'fa-regular fa-person-waving' },
  body2: { type: 'fa', icon: 'fa-regular fa-person-arms-raised' },
  christmasTree: { type: 'fa', icon: 'fa-regular fa-tree-christmas' },
  circle: { type: 'fa', icon: 'fa-regular fa-circle' },
  classics: { type: 'fa', icon: 'fa-regular fa-unicorn' },
  classics2: { type: 'fa', icon: 'fa-regular fa-hat-wizard' },
  cow: { type: 'fa', icon: 'fa-regular fa-cow' },
  difficultQuestions: { type: 'fa', icon: 'fa-regular fa-user-question' },
  dog: { type: 'fa', icon: 'fa-regular fa-dog' },
  downloaded: { type: 'fa', icon: 'fa-regular fa-circle-down' },
  duck: { type: 'fa', icon: 'fa-regular fa-duck' },
  empathy: { type: 'fa', icon: 'fa-regular fa-handshake-angle' },
  empathy2: { type: 'fa', icon: 'fa-regular fa-hearts' },
  favorite: { type: 'fa', icon: 'fa-regular fa-star' },
  feelings: { type: 'fa', icon: 'fa-regular fa-masks-theater' },
  football: { type: 'fa', icon: 'fa-regular fa-futbol' },
  forest: { type: 'fa', icon: 'fa-regular fa-trees' },
  friendship: { type: 'fa', icon: 'fa-regular fa-user-group' },
  frog: { type: 'fa', icon: 'fa-regular fa-frog' },
  tRex: { type: 'fa', icon: 'fa-regular fa-t-rex' },
  happy: { type: 'fa', icon: 'fa-regular fa-face-smile' },
  heart: { type: 'fa', icon: 'fa-regular fa-heart' },
  history: { type: 'fa', icon: 'fa-regular fa-clock-rotate-left' },
  lightning: { type: 'fa', icon: 'fa-regular fa-bolt-lightning' },
  mathematics: { type: 'fa', icon: 'fa-regular fa-calculator' },
  me: { type: 'fa', icon: 'fa-regular fa-user-circle' },
  nature: { type: 'fa', icon: 'fa-regular fa-seedling' },
  news: { type: 'fa', icon: 'fa-regular fa-newspaper' },
  normsAndValues: { type: 'fa', icon: 'fa-regular fa-users-viewfinder' },
  otherCountries: { type: 'fa', icon: 'fa-regular fa-earth-americas' },
  pegasus: { type: 'fa', icon: 'fa-regular fa-pegasus' },
  rudolph: { type: 'fa', icon: 'fa-regular fa-deer-rudolph' },
  scary: { type: 'fa', icon: 'fa-regular fa-ghost' },
  seasons: { type: 'fa', icon: 'fa-regular fa-snowflake' },
  seasons2: { type: 'fa', icon: 'fa-regular fa-leaf' },
  shared: { type: 'fa', icon: 'fa-regular fa-users' },
  spider: { type: 'fa', icon: 'fa-regular fa-spider' },
  star: { type: 'fa', icon: 'fa-regular fa-star' },
  sun: { type: 'fa', icon: 'fa-regular fa-sun' },
  teddyBear: { type: 'fa', icon: 'fa-regular fa-teddy-bear' },
  technology: { type: 'fa', icon: 'fa-regular fa-robot' },
  thinPhotoFilm: { type: 'fa', icon: 'fa-thin fa-photo-film' },
  whale: { type: 'fa', icon: 'fa-regular fa-whale' },
  binoculars: { type: 'fa', icon: 'fa-regular fa-binoculars' },
  comet: { type: 'fa', icon: 'fa-regular fa-comet' },
  galaxy: { type: 'fa', icon: 'fa-regular fa-galaxy' },
  moon: { type: 'fa', icon: 'fa-regular fa-moon' },
  planetRinged: { type: 'fa', icon: 'fa-regular fa-planet-ringed' },
  satellite: { type: 'fa', icon: 'fa-regular fa-satellite' },
  shuttleSpaceVertical: { type: 'fa', icon: 'fa-regular fa-shuttle-space-vertical' },
  ufo: { type: 'fa', icon: 'fa-regular fa-ufo' },
  alien: { type: 'fa', icon: 'fa-regular fa-alien' },
  userAstronaut: { type: 'fa', icon: 'fa-regular fa-user-astronaut' },
  cactus: { type: 'fa', icon: 'fa-regular fa-cactus' },
  feather: { type: 'fa', icon: 'fa-regular fa-feather' },
  leaf: { type: 'fa', icon: 'fa-regular fa-leaf' },
  mountain: { type: 'fa', icon: 'fa-regular fa-mountain' },
  tree: { type: 'fa', icon: 'fa-regular fa-tree' },
  treePalm: { type: 'fa', icon: 'fa-regular fa-tree-palm' },
  wave: { type: 'fa', icon: 'fa-regular fa-wave' },
  wind: { type: 'fa', icon: 'fa-regular fa-wind' },
  atom: { type: 'fa', icon: 'fa-regular fa-atom' },
  dna: { type: 'fa', icon: 'fa-regular fa-dna' },
  flask: { type: 'fa', icon: 'fa-regular fa-flask' },
  magnet: { type: 'fa', icon: 'fa-regular fa-magnet' },
  microscope: { type: 'fa', icon: 'fa-regular fa-microscope' },
  baseball: { type: 'fa', icon: 'fa-regular fa-baseball' },
  basketball: { type: 'fa', icon: 'fa-regular fa-basketball' },
  bowlingBall: { type: 'fa', icon: 'fa-regular fa-bowling-ball' },
  dumbbell: { type: 'fa', icon: 'fa-regular fa-dumbbell' },
  hockey: { type: 'fa', icon: 'fa-regular fa-hockey-stick' },
  racquet: { type: 'fa', icon: 'fa-regular fa-racquet' },
  stadium: { type: 'fa', icon: 'fa-regular fa-stadium' },
  tennisBall: { type: 'fa', icon: 'fa-regular fa-tennis-ball' },
  volleyball: { type: 'fa', icon: 'fa-regular fa-volleyball' },
  bells: { type: 'fa', icon: 'fa-regular fa-bells' },
  candyCane: { type: 'fa', icon: 'fa-regular fa-candy-cane' },
  gift: { type: 'fa', icon: 'fa-regular fa-gift' },
  gingerbreadMan: { type: 'fa', icon: 'fa-regular fa-gingerbread-man' },
  jackOLanter: { type: 'fa', icon: 'fa-regular fa-jack-o-lantern' },
  pinata: { type: 'fa', icon: 'fa-regular fa-pinata' },
  snowman: { type: 'fa', icon: 'fa-regular fa-snowman' },
  alien8Bit: { type: 'fa', icon: 'fa-regular fa-alien-8bit' },
  blockQuestion: { type: 'fa', icon: 'fa-regular fa-block-question' },
  chess: { type: 'fa', icon: 'fa-regular fa-chess' },
  dice: { type: 'fa', icon: 'fa-regular fa-dice' },
  gamepad: { type: 'fa', icon: 'fa-regular fa-gamepad' },
  joystick: { type: 'fa', icon: 'fa-regular fa-joystick' },
  pinball: { type: 'fa', icon: 'fa-regular fa-pinball' },
  puzzle: { type: 'fa', icon: 'fa-regular fa-puzzle' },
  baseballBat: { type: 'fa', icon: 'fa-regular fa-baseball-bat' },
  medal: { type: 'fa', icon: 'fa-regular fa-medal' },
  biohazard: { type: 'fa', icon: 'fa-regular fa-biohazard' },
  brain: { type: 'fa', icon: 'fa-regular fa-brain' },
  capsule: { type: 'fa', icon: 'fa-regular fa-capsule' },
  cauldron: { type: 'fa', icon: 'fa-regular fa-cauldron' },
  circleRadiation: { type: 'fa', icon: 'fa-regular fa-circle-radiation' },
  fire: { type: 'fa', icon: 'fa-regular fa-fire' },
  vial: { type: 'fa', icon: 'fa-regular fa-vial' },
  treasureChest: { type: 'fa', icon: 'fa-regular fa-treasure-chest' },
  sword: { type: 'fa', icon: 'fa-regular fa-sword' },
  dragon: { type: 'fa', icon: 'fa-regular fa-dragon' },
  ghost: { type: 'fa', icon: 'fa-regular fa-ghost' },
  dove: { type: 'fa', icon: 'fa-regular fa-dove' },
  rabbit: { type: 'fa', icon: 'fa-regular fa-rabbit' },
  horseSaddle: { type: 'fa', icon: 'fa-regular fa-horse-saddle' },
  dinosaur: { type: 'fa', icon: 'fa-regular fa-dinosaur' },
  ant: { type: 'fa', icon: 'fa-regular fa-ant' },
  solarSystem: { type: 'fa', icon: 'fa-regular fa-solar-system' },
  starShooting: { type: 'fa', icon: 'fa-regular fa-star-shooting' },
  telescope: { type: 'fa', icon: 'fa-regular fa-telescope' },
  puzzlePiece: { type: 'fa', icon: 'fa-regular fa-puzzle-piece' },
  bug: { type: 'fa', icon: 'fa-regular fa-bug' },
  cloudSun: { type: 'fa', icon: 'fa-regular fa-cloud-sun' },
  personRunning: { type: 'fa', icon: 'fa-regular fa-person-running' },
  bicycle: { type: 'fa', icon: 'fa-regular fa-bicycle' },
  courtSport: { type: 'fa', icon: 'fa-regular fa-court-sport' },
  bookOpenLines: { type: 'fa', icon: 'fa-regular fa-book-open-lines' },
  bookBlank: { type: 'fa', icon: 'fa-regular fa-book-blank' },
  personChalkboard: { type: 'fa', icon: 'fa-regular fa-person-chalkboard' },
  school: { type: 'fa', icon: 'fa-regular fa-school' },
  music: { type: 'fa', icon: 'fa-regular fa-music' },
  diploma: { type: 'fa', icon: 'fa-regular fa-diploma' },
  balloon: { type: 'fa', icon: 'fa-regular fa-balloon' },
  backpack: { type: 'fa', icon: 'fa-regular fa-backpack' },
  family: { type: 'fa', icon: 'fa-regular fa-family' },
  circus: { type: 'fa', icon: 'fa-regular fa-tent-circus' },
  candy: { type: 'fa', icon: 'fa-regular fa-candy' },
  cakeCandles: { type: 'fa', icon: 'fa-regular fa-cake-candles' },
  appleWhole: { type: 'fa', icon: 'fa-regular fa-apple-whole' },
  pizzaSlice: { type: 'fa', icon: 'fa-regular fa-pizza-slice' },
  popcorn: { type: 'fa', icon: 'fa-regular fa-popcorn' },
  mugHot: { type: 'fa', icon: 'fa-regular fa-mug-hot' },
  cupcake: { type: 'fa', icon: 'fa-regular fa-cupcake' },
  carBus: { type: 'fa', icon: 'fa-regular fa-car-bus' },
  carSide: { type: 'fa', icon: 'fa-regular fa-car-side' },
  truckMonster: { type: 'fa', icon: 'fa-regular fa-truck-monster' },
  truck: { type: 'fa', icon: 'fa-regular fa-truck' },
  motorcycle: { type: 'fa', icon: 'fa-regular fa-motorcycle' },
  tentCircus: { type: 'fa', icon: 'fa-regular fa-tent-circus' },
};

export default { icons };
